import { JetView } from 'webix-jet'; // Importing JetView from webix-jet for creating views
import { devConfig, countries, profile, walletsList } from 'config/config'; // Importing configuration settings

/**
 * Class representing the FilterSignificantEventsAndAlterationsReportsView.
 * @extends JetView
 */
export default class FilterSignificantEventsAndAlterationsReportsView extends JetView {
    /**
     * Configures the view layout and components.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service for translations
        const left = {
            id: 'a1',
            margin: 5,
            rows: [
                {
                    responsive: 'a1',
                    margin: 15,
                    css: 'on-row',
                    cols: [
                        {
                            id: 'Datepicker', // Datepicker component for selecting date range
                            name: 'Datepicker',
                            view: 'text',
                            css: 'reportrange',
                            value:
                                moment().subtract(0, 'days').format('YYYY-MM-DD') +
                                ' - ' +
                                moment().format('YYYY-MM-DD'),
                            label: "<span class='webix_icon icon-calendar'></span>" + _('Fecha'), // Label for the datepicker
                            labelPosition: 'top',
                            minWidth: 200,
                            placeholder: _('Click para seleccionar '), // Placeholder text
                        },
                        {
                            id: 'Date', // Date component for selecting a single date
                            name: 'Date',
                            view: 'datepicker',
                            stringResult: true,
                            minWidth: 200,
                            label: "<span class='webix_icon icon-calendar'></span>" + _('Fecha'), // Label for the date component
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '), // Placeholder text
                            value: moment().format('YYYY-MM-DD'), // Default value
                            format: '%d %M %Y', // Date format
                            suggest: {
                                type: 'calendar',
                                body: {
                                    maxDate: new Date(), // Maximum selectable date
                                },
                            },
                        },
                        screen.width > 600 ? {} : { height: 1, width: 0 }, // Responsive design adjustment
                    ],
                },
            ],
        };
        const upper_section = {
            css: 'father-container',
            rows: [
                {
                    margin: 10,
                    cols: [left], // Left section containing date components
                },
            ],
        };
        const buttons = {
            cols: [
                {},
                {
                    view: 'button', // Button to add an event
                    value: _('Añadir Evento'),
                    width: screen === 'small' ? 0 : 200,
                    maxWidth: 200,
                    hidden: !devConfig.getPermAction(
                        'EventsAndAlterationsAdd',
                        'Add', // Check for permissions to show button
                    ),
                    click: () => {
                        webix
                            .ui({
                                view: 'window', // Modal window for adding an event
                                id: 'addEventModal',
                                fullscreen: screen.width < 500,
                                position: 'center',
                                modal: true,
                                head: 'Añadir Evento', // Header of the modal
                                body: {
                                    view: 'form',
                                    id: 'addEventForm', // Form for adding event details
                                    width: screen.width < 500 ? 350 : 450,
                                    height: screen.width < 500 ? 600 : 400,
                                    elements: [
                                        {
                                            view: 'datepicker', // Datepicker for event date and time
                                            label: 'Fecha y hora',
                                            name: 'Date',
                                            id: 'Date',
                                            timepicker: true,
                                            labelPosition: screen.width < 500 ? 'top' : 'left',
                                            labelWidth: 150,
                                            value: new Date(), // Default value
                                        },
                                        {
                                            view: 'text', // Input for user ID
                                            label: 'ID Usuario',
                                            name: 'Users',
                                            id: 'Users',
                                            type: 'number',
                                            labelPosition: screen.width < 500 ? 'top' : 'left',
                                            labelWidth: 150,
                                            css: 'webix_inputNumber',
                                        },
                                        {
                                            view: 'text', // Input for value before alteration
                                            label: 'Valor antes de la alteración',
                                            name: 'ValueBeforeAlteration',
                                            id: 'ValueBeforeAlteration',
                                            labelPosition: screen.width < 500 ? 'top' : 'left',
                                            labelWidth: 230,
                                        },
                                        {
                                            view: 'text', // Input for value after alteration
                                            label: 'Valor después de la alteración',
                                            name: 'ValueAfterAlteration',
                                            id: 'ValueAfterAlteration',
                                            labelPosition: screen.width < 500 ? 'top' : 'left',
                                            labelWidth: 230,
                                        },
                                        {
                                            view: 'textarea', // Textarea for reason/description
                                            label: 'Motivo/descripción',
                                            name: 'ReasonDescription',
                                            id: 'ReasonDescription',
                                            labelPosition: 'top',
                                            inputHeight: 100,
                                            height: 130,
                                        },
                                        {
                                            cols: [
                                                {
                                                    view: 'button', // Cancel button
                                                    value: 'Cancelar',
                                                    click: function () {
                                                        this.getTopParentView().hide(); // Hide modal on cancel
                                                    },
                                                },
                                                {
                                                    view: 'button', // Save button
                                                    value: 'Guardar',
                                                    type: 'form',
                                                    click: function () {
                                                        const form = $$('addEventForm'); // Get form instance
                                                        if (form.validate()) {
                                                            // Validate form
                                                            console.log(
                                                                form.getValues(), // Log form values
                                                            );
                                                            webix
                                                                .ajax()
                                                                .headers({
                                                                    'Content-type': 'application/json', // Set content type for AJAX request
                                                                })
                                                                .post(
                                                                    devConfig.geturlApi() +
                                                                        'es/Financial/AddSignificantEventsAndAlterations', // API endpoint
                                                                    {
                                                                        ...form.getValues(),
                                                                        Date: new Date(form.getValues().Date).getTime(), // Convert date to timestamp
                                                                    },
                                                                    {
                                                                        error: function (text, data, XmlHttpRequest) {
                                                                            webix.message({
                                                                                title: _('¡Mensaje!'),
                                                                                type: 'alert-error',
                                                                                text: _(
                                                                                    'Ocurrio un error.', // Error message
                                                                                ),
                                                                            });
                                                                        },
                                                                        success: function (text, data, XmlHttpRequest) {
                                                                            text = JSON.parse(
                                                                                text, // Parse response
                                                                            );
                                                                            console.log(text);
                                                                            if (
                                                                                text.HasError // Check for errors in response
                                                                            ) {
                                                                                webix.message({
                                                                                    title: _('¡Mensaje!'),
                                                                                    type: 'alert-error',
                                                                                    text: _(
                                                                                        'Ocurrio un error al agregar el evento.', // Error message for adding event
                                                                                    ),
                                                                                });
                                                                            } else {
                                                                                webix.alert({
                                                                                    title: 'Notificación',
                                                                                    text: _(
                                                                                        'El evento se ha añadido correctamente', // Success message
                                                                                    ),
                                                                                });
                                                                            }
                                                                        },
                                                                    },
                                                                );
                                                            this.getTopParentView().hide(); // Hide modal after saving
                                                        }
                                                    },
                                                },
                                            ],
                                        },
                                    ],
                                    rules: {
                                        Date: webix.rules.isNotEmpty, // Validation rule for date
                                        Users: webix.rules.isNotEmpty, // Validation rule for user ID
                                        ReasonDescription: webix.rules.isNotEmpty, // Validation rule for reason/description
                                        ValueBeforeAlteration: webix.rules.isNotEmpty, // Validation rule for value before alteration
                                        ValueAfterAlteration: webix.rules.isNotEmpty, // Validation rule for value after alteration
                                    },
                                },
                            })
                            .show(); // Show modal
                    },
                },
                {
                    view: 'button', // Button to clear filters
                    value: _('Limpiar'),
                    width: screen == 'small' ? 0 : 100,
                    minWidth: 200,
                    click: () => {
                        $$('myForm').setValues($$('myForm').getCleanValues()); // Reset form values
                        $$('CountrySelect').setValue($$('myForm').getCleanValues().CountrySelect); // Reset country selection
                        $$('Datepicker').setValue(''); // Clear datepicker
                    },
                },
                {
                    id: 'consultDesk', // Button to consult/filter events
                    view: 'button',
                    value: _('Consultar'),
                    hotkey: 'enter', // Shortcut key for consultation
                    type: 'form',
                    width: screen == 'small' ? 0 : 100,
                    click: () => {
                        const filterdata = this.getRoot().getValues(); // Get filter values
                        if (devConfig.getCountryReport()) {
                            filterdata.CountrySelect = profile.Settings.ReportCountry; // Set country filter if applicable
                        }
                        delete filterdata['CountrySelect2']; // Remove unnecessary field
                        if (profile.typeDate !== 2) {
                            delete filterdata['Date']; // Remove date field if not needed
                        } else {
                            if (true) {
                                delete filterdata['Datepicker']; // Remove datepicker if needed
                            }
                        }
                        this.app.callEvent(
                            'significantEventsAndAlterations:filter',
                            [filterdata], // Trigger filter event with data
                        );
                        $$('b5').collapse(); // Collapse filter section
                        $$('a5').scrollTo(100, 0); // Scroll to specific position
                    },
                },
            ],
        };
        const buttons2 = {
            padding: 10,
            cols: [
                {
                    view: 'button', // Button to clear filters in second form
                    value: _('Limpiar'),
                    click: () => {
                        $$('myForm2').setValues($$('myForm2').getCleanValues()); // Reset second form values
                        $$('CountrySelect').setValue($$('myForm2').getCleanValues().CountrySelect); // Reset country selection
                        $$('Datepicker').setValue(''); // Clear datepicker
                    },
                },
                {
                    id: 'consultDesk', // Button to consult/filter events in second form
                    view: 'button',
                    value: _('Consultar'),
                    hotkey: 'enter', // Shortcut key for consultation
                    type: 'form',
                    click: () => {
                        const filterdata = $$('myForm2').getValues(); // Get filter values from second form
                        if (devConfig.getCountryReport()) {
                            filterdata.CountrySelect = profile.Settings.ReportCountry; // Set country filter if applicable
                        }
                        delete filterdata['CountrySelect2']; // Remove unnecessary field
                        if (profile.typeDate !== 2) {
                            delete filterdata['Date']; // Remove date field if not needed
                        } else {
                            if (true) {
                                delete filterdata['Datepicker']; // Remove datepicker if needed
                            }
                        }
                        this.app.callEvent(
                            'significantEventsAndAlterations:filter',
                            [filterdata], // Trigger filter event with data
                        );
                    },
                },
            ],
        };
        const accordion_section2 = {
            type: 'wide',
            rows: [
                {
                    multi: true,
                    view: 'accordion', // Accordion for filters
                    css: 'betShop',
                    collapsed: true,
                    type: 'clean',
                    rows: [
                        {
                            id: 'b5',
                            header: _('Filtros'), // Header for filters
                            body: {
                                padding: 10,
                                rows: [upper_section, buttons], // Upper section and buttons
                            },
                        },
                    ],
                },
            ],
        };
        const accordion_section3 = {
            view: 'scrollview', // Scrollable view for filters
            scroll: 'xy',
            body: {
                padding: 10,
                rows: [upper_section], // Upper section for filters
            },
        };
        const filterPopup = webix.ui({
            view: 'window', // Popup window for filters
            move: true,
            id: 'filterPopup',
            fullscreen: true,
            modal: true,
            position: 'center',
            head: {
                view: 'toolbar',
                cols: [
                    { view: 'label', label: _('Filtros'), align: 'center' }, // Label for popup
                    {
                        view: 'icon',
                        icon: 'wxi-close', // Close icon for popup
                        click: function () {
                            this.getTopParentView().hide(); // Hide popup on close
                        },
                    },
                ],
            },
            body: {
                view: 'form',
                id: 'myForm2', // Second form for filters
                type: 'clean',
                rows: [accordion_section3, buttons2], // Accordion section and buttons
                rules: {
                    fname: webix.rules.isNotEmpty, // Validation rule for form
                },
            },
        });
        return {
            id: 'myForm', // Main form ID
            view: 'form',
            type: 'clean',
            rows: [
                screen.width > 500 && screen.height > 500
                    ? accordion_section2 // Show accordion section if screen size is sufficient
                    : { height: 1, width: 0 },
            ],
            rules: {
                fname: webix.rules.isNotEmpty, // Validation rule for form
            },
        };
    }

    /**
     * Initializes the view and sets up event listeners.
     * @param {Object} grid - The grid instance.
     */
    init(grid) {
        webix.ready(function () {
            if (profile.typeDate !== 2) {
                $$('Date').hide(); // Hide date input if typeDate is not 2
                $$('Datepicker').show(); // Show datepicker
            } else {
                $$('Date').show(); // Show date input
                $$('Datepicker').hide(); // Hide datepicker
            }
        });
        const lang = this.app.getService('locale').getLang(); // Get current language
        $$('Datepicker').attachEvent('onAfterRender', function () {
            devConfig.setDateModal(lang); // Set date modal based on language
        });
    }
}

// FILE DOCUMENTED
